export const fetchLazy = async <T = any>(fetchPromise: Promise<T>) => {
  if (import.meta.server) {
    await fetchPromise
  }
}

export const fetchOnNavigation = async <T = any>(
  fetch: () => Promise<T>,
  key?: string,
) => {
  const route = useRoute()
  const suffix = key ? `-${key}` : ''

  const currentPath = useState<string | undefined>(
    `currentPath${suffix}`,
    () => undefined,
  )
  if (import.meta.server) {
    if (currentPath.value === undefined) {
      currentPath.value = route.path
    }
    await fetch()
  } else {
    // ECOM-2692: the `prefetchedUrls` useState that previously gated this fetch
    // was never written anywhere, so it was always empty — dead code, removed.
    // Behavior is unchanged: the client fetch fires whenever the live route
    // differs from the last path this gate ran for.
    //
    // This gate is one-shot (setup-time) and does not re-run on a popstate
    // navigation that lands mid-hydration — that case is self-healed by
    // usePlpNavigationReconcile. Re-arming this shared gate (the layout's
    // expensive fetchData uses it too) is deferred until production telemetry
    // shows it's needed.
    if (currentPath.value !== route.path) {
      fetch()
      currentPath.value = route.path
    }
  }
}
